import { WithDisposable } from '@blocksuite/block-std';
import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
// import { choose } from 'lit/directives/choose.js';
// import { styleMap } from 'lit/directives/style-map.js';

@customElement('edgeless-chroma')
export class EdgelessChroma extends WithDisposable(LitElement) {
  static override styles = css`
    :host {
      align-items: normal !important;
      gap: 16px !important;
      flex-direction: column;
      min-width: 198px;
      min-height: 200px;
      padding: 8px;
    }

    .content {
      display: flex;
      flex-direction: column;
      gap: inherit;
    }

    .color-area {
      position: relative;
      color: red;
      width: 100%;
      height: 171px;
    }

    .color-area::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      background-image: linear-gradient(rgba(0, 0, 0, 0), #000),
        linear-gradient(90deg, #fff, currentColor);
      border-radius: 4px;
      overflow: hidden;
    }

    .color-slider {
      position: relative;
      width: 100%;
      height: 12px;
    }
    .color-slider::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      background-image: linear-gradient(
        to left,
        #ff0008 0,
        #ff00eb 16.6667%,
        #0e00ff 32.8125%,
        #00edff 49.0625%,
        #00ff00 67.9688%,
        #fffe00 83.125%,
        #ff0800 100%
      );
      border-radius: 4px;
      overflow: hidden;
    }

    footer {
      display: flex;
      justify-content: space-between;
    }

    input {
      box-sizing: border-box;
    }

    input.color {
      width: 134px;
    }

    input.opacity {
      width: 56px;
    }
  `;

  override firstUpdated() {}

  override render() {
    return html`
      <header>
        <nav>
          <button>Colors</button>
          <button>Custom</button>
        </nav>
      </header>

      <div class="content">
        <div class="color-area"></div>

        <div class="color-slider"></div>
      </div>

      <footer>
        <input class="color" type="text" placeholder="#000" />
        <input class="opacity" type="text" placeholder="100%" />
      </footer>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'edgeless-chroma': EdgelessChroma;
  }
}
